import { Injectable } from '@angular/core';
import { select } from '@ngrx/store';
import { BaseStore } from './base-store';
import { Observable } from 'rxjs';
import { getAccessCodeDetailsIsActive } from '@shared/store/selectors';

@Injectable()
export class AccessCodeDetailsStore extends BaseStore {
	get isActive(): Observable<boolean> {
		return this.store.pipe(select(getAccessCodeDetailsIsActive));
	}
}
